/**
 * AddActionsMenuColumn Handler для Table
 * 
 * Додає колонку з меню дій (трикрапка) в таблицю
 * 
 * Налаштування через crudContext.settings:
 * - tableIsActionsColumnHide: boolean - приховати колонку
 * - tableActionsColumnPosition: 'start' | 'end' - позиція колонки (за замовчуванням 'start')
 * - tableActionsColumnWidth: number - ширина колонки (за замовчуванням 40)
 */

/**
 * Додає колонку з меню дій
 * 
 * @param params - об'єкт з параметрами
 * @param params.columns - масив колонок таблиці
 * @param params.tableContext - контекст таблиці
 */
export const AddActionsMenuColumn = ({ columns, tableContext }: { columns: any[], tableContext: any }) => {
    const crudContext = tableContext.storages?.crudContext
    
    if (crudContext?.settings?.tableIsActionsColumnHide === true) return
    
    if (columns.filter((column) => column.key === '_actions').length === 0) {
        const position = crudContext?.settings?.tableActionsColumnPosition ?? 'start'
        const width = crudContext?.settings?.tableActionsColumnWidth ?? 40
        
        const actionsColumn = {
            title: 'Дії',
            dataIndex: '_actions',
            key: '_actions',
            width,
            fixed: position === 'start' ? 'left' : 'right',
        }
        
        if (position === 'end') {
            columns.push(actionsColumn)
        } else {
            columns.unshift(actionsColumn)
        }
    }
}

